import axios, { AxiosRequestConfig } from 'axios';

import { ApiSuccessResponse } from './types';

type Params = {
  data?: AxiosRequestConfig['data'];
  params?: AxiosRequestConfig['params'];
  signal?: AxiosRequestConfig['signal'];
};

export function httpGet<T>(url: string, params?: Params) {
  return axios.get<ApiSuccessResponse<T>>(url, params);
}
